module.exports = __webpack_public_path__ + "l.no1.ceba6ab7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/female_to_male/l.no1.jpg
// module id = /1O/
// module chunks = 0